import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { tlang } from '../language/lang.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html } from 'lit';
import { globalLanguageDebugMode } from '../../../localization/global-language-debug';

export function asMarkdown(data: string | string[] | undefined | null, trimBlanks = true): string {
  if (!data) return '';

  if (globalLanguageDebugMode() && typeof data === 'string' && data.startsWith('<*') && data.endsWith('*>')) {
    data = `<*this multiline data has been localized localized*>\n${data.slice(2, -2)}`;
  }

  if (trimBlanks) {
    const newdata = typeof data === 'string' ? data.split('\n') : data;
    data = newdata
      .map(line => {
        let newLine = line.trimStart();
        while (newLine.trimStart().startsWith('++')) {
          newLine = newLine.replace('++', '  +');
        }

        return newLine;
      })
      .join('\n');
  } else {
    data = typeof data === 'string' ? data : data.join('\n');
  }
  marked.setOptions({ gfm: true, breaks: true });
  return DOMPurify.sanitize(marked.parse(data, { async: false }));
}

export function asMarkdownTemplate(data: string | string[] | undefined | null, trimBlanks = true) {
  return unsafeHTML(asMarkdown(data, trimBlanks));
}

export function asMarkdownTemplateResult(data: string | string[] | undefined | null, trimBlanks = true) {
  return html`${unsafeHTML(asMarkdown(data, trimBlanks))}`;
}

export function stringsAsMarkdownList(data: string[] | null | undefined) {
  return (data ?? []).map(x => `+ ${x}`).join('\n');
}

export function tlangMarkdown(template: TemplateStringsArray, ...args: any[]) {
  const data = tlang(template, ...args);
  return asMarkdownTemplate(data);
}

export function tlangMarkdownTemplate(template: TemplateStringsArray, ...args: any[]) {
  const data = tlang(template, ...args);
  return asMarkdownTemplateResult(data);
}
